import React from 'react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
export function FinalCtaSection() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-48" data-mp="3lsvcphb0sctf">
      <div className="mx-auto max-w-xl text-center" data-id="element-49" data-mp="3qt9p1bjnm8x9">
        <h2 className="font-display text-[1.5rem] font-extrabold leading-tight text-brand-deep sm:text-3xl" data-id="element-50" data-mp="3qrgidw91jop9">
          Empieza hoy tu reinicio metabólico con una guía clara, simple y 100%
          digital.
        </h2>

        <div className="mx-auto mt-7 max-w-md sm:mt-8" data-id="element-51" data-mp="333p3qm012zkt">
          <CtaButton href="#precio" location="cierre" data-id="element-52" data-mp="334gqd7bndmyy">
            Empezar mi reinicio
          </CtaButton>
          <Reassurance className="mt-3" items={['Pago único de $27 USD', 'Ahorras $130 USD', 'Acceso inmediato', 'Sin suscripciones']} data-id="element-53" data-mp="381qi4tmieapy" />
        </div>
      </div>
    </section>;
}